import { useCallback, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { useAtomValue } from 'jotai'
import { authenticationState } from '@repo/unicity'
import { CheckoutBreadcrumb } from '@/core/components'
import type { BreadcrumbStep } from '@/core/components'

type StepKey = 'customise' | 'shipping' | 'purchase'

const CheckoutStepper = ({ activeStep }: { activeStep: StepKey }) => {
    const authentication = useAtomValue(authenticationState)
    const isAuthenticated = Boolean(authentication.token && authentication.baId)

    const steps: (BreadcrumbStep & { path: string })[] = useMemo(
        () => [
            { key: 'customise', label: 'customise', path: '/products' },
            { key: 'shipping', label: isAuthenticated ? 'shipping' : 'signup_shipping', path: '/checkout/shipping' },
            { key: 'purchase', label: 'purchase', path: '/checkout/payment' }
        ],
        [isAuthenticated]
    )
    const activeIndex = steps.findIndex(s => s.key === activeStep)
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const handleStepClick = useCallback(
        (index: number) => {
            const step = steps[index]
            if (!step) return
            const uuid = searchParams.get('uuid')
            const path = uuid && step.key !== 'customise' ? `${step.path}?uuid=${uuid}` : step.path
            navigate(path)
        },
        [navigate, searchParams, steps]
    )

    return (
        <CheckoutBreadcrumb
            steps={steps}
            activeIndex={activeIndex}
            onStepClick={handleStepClick}
            sx={{ mt: '32px' }}
            data-testid="checkout-stepper-checkout-breadcrumb"
        />
    )
}

export default CheckoutStepper
